/**
 * Simple await Proimise function to delay JS syncronously
 * @param  {number} duration Time to sleep for
 */
export async function sleep(duration: number) {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), duration);
  });
}
